<template>
	<form ref="devices_add" @submit.prevent="updateDevices">
		<md-card>
			<md-card-header class="md-card-header-icon md-card-header-blue">
				<div class="card-icon">
					<md-icon>edit</md-icon>
				</div>
				<h4 class="title">Modification des dispositifs</h4>
			</md-card-header>
			<md-card-content>
				<template v-if="devices.length > 0">
                    <device-row v-for="(device, index) in devices" :key="device.id" :idRow="'rowDevice-' + index"
                                :device="device" :errors="errors" :is-edit-row="true"
                                @delete="handleDelete"></device-row>
                </template>
                <p v-else>Aucun dispositif sur ce site</p>
			</md-card-content>
			<md-card-actions md-alignment="left">
				<md-button type="submit" class="md-success">
					Enregistrer
				</md-button>
				<md-button class="md-warning"
						   @click="goBack">
					Retour
				</md-button>
			</md-card-actions>
		</md-card>
	</form>
</template>

<script>
import DeviceRow from "@/pages/Sites/Devices/components/DeviceRow";

export default {
	name: "DeviceEditForm",
	components: { DeviceRow },
	props: {
		devices: Array,
	},
	data() {
		return {
			errors: []
		}
	},
	methods: {
		async updateDevices() {
		    this.errors = []
            try {
                await this.$store.dispatch('devices/updateDevices', { id: this.$route.params.idSite, devices: this.devices })
                await this.$store.dispatch('alerts/success', 'Dispositifs modifiés')
                this.$emit('updated')
            } catch (e) {
                this.errors = e.response.data.errors
            }
		},
		handleDelete(device) {
			this.$swal.fire({
				title: "Êtes-vous sûr ?",
                html: `Voulez-vous supprimer le dispositif <b>numéro ${device.number}</b> ?`,
				icon: "warning",
				showCancelButton: true,
				confirmButtonClass: "md-button md-success",
				cancelButtonClass: "md-button md-warning",
				confirmButtonText: "Supprimer",
				cancelButtonText: "Annuler",
				buttonsStyling: false,
			}).then(async result => {
				if(result.value) {
					try {
						await this.$store.dispatch('devices/deleteDevice', { id: device.id })
						await this.$store.dispatch('alerts/success', 'Dispositif supprimé')
						this.$emit('deleted')
					}
					catch(e) {
						await this.$store.dispatch("alerts/error", "Suppression impossible")
					}
				}
			});
		},
		goBack() {
			this.$router.back()
		}
	}
}
</script>

<style scoped>

</style>
